import { isProduction } from "@/is-production";

export const getIsProduction = async () => {
  return isProduction;
};
